import { useContext, useEffect, useState } from "react";
import ProductOptions from "./ForOrderOptions/ProductOptions";
import { CurrentPContext, MasterContext, OrderContext } from "../../ContextApi/context";
import TheMount from "../../OrderSettings/TheMount";
import ConnUrls from "../../Connections/ConnectURL";
import ProductComboOptions from "./ForOrderOptions/ProductComboOptions";
import OrderFunctions from "../../OrderSettings/OrderFunctions";

const ProductItemDeskTopRegular = (props) => {

    const [order, setOrder] = useContext(OrderContext);
    const [master] = useContext(MasterContext);
    const [currentPage, setCurrentPage] = useContext(CurrentPContext);

    const [duplicates, setDuplicates] = useState([]);
    const [btnAddToOrder, setBtnAddToOrder] = useState({ txt: "הוסף להזמנה", ordID: -1 });
    const [sizeOfimg, setSizeOfimg] = useState("small");
    const [imInOrder, setImInOrder] = useState(false);
    const [popMeUp, setPopMeUp] = useState({ timestamp: 0, itemId: null });
    const [inOrderIndex, setInOrderIndex] = useState(-1);
    const isOutOfStock = !props.divitm.inStock || false;
    const [specials, setSpecials] = useState([]);
    const [addsPrice, setAddsPrice] = useState(0);
    const [mountToOrd, setMountToOrd] = useState(0);

    useEffect(() => {
        if (props.autoOpenOptions && !isOutOfStock) {
            firstTimeOrdClick();
        }
    }, []);

    useEffect(() => {
        let chkInOrder = (order.restId == currentPage._id);
        if (chkInOrder) {
            let getItm = order.Orders.findIndex(
                el => el.ordProdID == props.itemId &&
                    (el.orderDiviId == props.divitm._id || props.divitm._id.ObjectId))

            if (getItm != -1) {
                if (!imInOrder) {
                    setInOrderIndex(getItm);
                    setSizeOfimg("big");
                    setImInOrder(true);
                }
            } else {
                if (imInOrder) {
                    setImInOrder(false);
                    setSizeOfimg("small");
                    setInOrderIndex(-1);
                }
            }
        }
    }, [order]);

    const tempOrderProds = (prods, calculatedAddsPrice = null) => {
        let tempAddsPrice = 0;

        if (calculatedAddsPrice !== null) {
            tempAddsPrice = calculatedAddsPrice;
        } else {
            prods.map((item, index) => {
                item.spec.map((prc, ind) => {
                    tempAddsPrice = parseFloat(tempAddsPrice) + parseFloat(prc.addToPrice);
                })
            })
        }

        setSpecials(prods);
        setAddsPrice(tempAddsPrice);
    }

    const addDuplicate = () => {
        setPopMeUp({ timestamp: 0, itemId: null });
        const newItemId = `${props.itemId}_dup_${Date.now()}`;
        let newDivItem = JSON.parse(JSON.stringify(props.divitm));

        if (newDivItem.prodOptions) {
            newDivItem.prodOptions = newDivItem.prodOptions.map(opt => ({
                ...opt,
                selected: Array.isArray(opt.selected) ? [] : 0
            }));
        }

        setDuplicates([...duplicates,
        <ProductItemDeskTopRegular
            key={newItemId}
            itemId={newItemId}
            divitm={newDivItem}
            doDeliver={props.doDeliver}
            doTakeAway={props.doTakeAway}
            onlyPhone={props.onlyPhone}
            myClass=""
            autoOpenOptions={true}
        />
        ]);
    }

    const firstTimeOrdClick = () => {
        if (isOutOfStock) return;
        setImInOrder(true);
        addToOrder();
        setPopMeUp({ timestamp: Date.now(), itemId: props.itemId });
    }

    const addToOrder = () => {
        if (isOutOfStock) return;

        let tmp = {
            ordProdID: props.itemId,
            productName: props.divitm.prodName,
            prodImageUrl: props.divitm.prodImageUrl,
            prodPrice: props.divitm.prodPrice,
            addsPrice: addsPrice,
            specials: specials,
            mount: parseInt(mountToOrd) + 1,
            orderItemId: props.itemId,
            cashRegMakat: props.divitm.cashRegMakat,
            orderDiviId: props.divitm._id,
            isCombo: props.divitm.isCombo ? props.divitm.isCombo : false,
            chkProdSauces: props.divitm.chkProdSauces ? props.divitm.chkProdSauces : false,
            chkProdValSauces: props.divitm.chkProdValSauces ? props.divitm.chkProdValSauces : "",
            prodInfo: props.divitm.prodInfo || "",
            unitPrice: props.divitm.unitPrice
        };

        // רשת ביטחון מפני סל מעורב: אם הסל עדיין שייך לעסק אחר, פותחים סל
        // חדש במקום לערבב מוצרים משני עסקים תחת הזמנה אחת.
        // בזרימה תקינה הלקוח כבר נשאל על כך בכניסה לעמוד (RestaurantPage).
        if (OrderFunctions.cartBelongsToOtherRest(order, currentPage._id)) {
            order.Orders = [];
        }

        order.Orders.push(tmp);
        setInOrderIndex(order.Orders.length - 1);
        order.restId = currentPage._id;
        order.restName = currentPage.buissName;
        order.GoogleLink = currentPage.GoogleLink;
        setOrder({ ...order });
    }

    const removeFromOrder = (ordItmId) => {
        setImInOrder(false);
        setPopMeUp({ timestamp: 0, itemId: null });
        let filt = order.Orders.filter(itm => itm.orderItemId != ordItmId)
        order.Orders = filt;
        setOrder({ ...order })
    }

    const smDisp = () => {
        let imgLnk = `${(props.divitm.prodImageUrl != null && props.divitm.prodImageUrl != "") ? props.divitm.prodImageUrl
            : (currentPage.mnuItemMainImg != null && currentPage.mnuItemMainImg != "") ? currentPage.mnuItemMainImg : ""}`
        imgLnk = (imgLnk != "") ? ConnUrls.media(imgLnk) : "";

        // אם המוצר לא במלאי - תצוגה פשוטה ללא כפתורים
        if (isOutOfStock) {
            return (
                <div id={`prodBlockS_${props.itemId}`} key={duplicates.length} className={`productDiv prodSmall outOfStock`}>
                    {imgLnk != "" &&
                        <div className={`prodImageWrap prodImageWrapSmall imageAndButtonsBlock`}>
                            <img className={"prodImage"} src={imgLnk} alt={currentPage.altTags || currentPage.pageName || ""} />
                        </div>
                    }
                    <div className="rightContent">
                        <div className={`MyFont mnuDivPrdcbold MbigFont`}>{props.divitm.prodName}</div>
                        {!imInOrder && <div className={"prodDetailsLong spaceTopBig"}>
                            <div className={"mnuDivPrdcReg"}>{props.divitm.prodProducts}</div>
                        </div>}
                        <div className="notForDelivery">אזל מהמלאי</div>
                        {((!master.blockDeliverys.block || !master.blockPickUps.block) && props.divitm.okToDeliver) &&
                            <div className={"priceln"}> ₪{props.divitm.prodPrice.toFixed(2)}</div>
                        }
                    </div>
                </div>
            )
        }

        // תצוגה רגילה למוצר זמין
        return (
            <div id={`prodBlockS_${props.itemId}`} key={duplicates.length}
                className={`productDiv prodSmall ${imInOrder ? "inOrderProd" : ""}`}>

                {imgLnk != "" &&
                    <div className={`prodImageWrap prodImageWrapSmall imageAndButtonsBlock`}>
                        <img className={"prodImage"} src={imgLnk} alt={currentPage.altTags || currentPage.pageName || ""} />
                        {((!master.blockDeliverys.block || !master.blockPickUps.block) &&
                            props.divitm.okToDeliver &&
                            !props.onlyPhone &&
                            props.myClass !== null) &&
                            <div className={"addToOrderBtnOnImage pointing"}></div>
                        }
                    </div>
                }

                {imInOrder ? (
                    <div className="statusAndCountBlock">
                        <div className="statusText">אני בהזמנה</div>
                        <div className="countControls">
                            <TheMount itemId={props.itemId} remFromOrder={() => removeFromOrder(props.itemId)} />
                        </div>
                        {((!master.blockDeliverys.block || !master.blockPickUps.block) && props.divitm.okToDeliver) &&
                            <div className="buttonsUnderImage">
                                {props.divitm.prodOptions.length > 0 && (
                                    <>
                                        <button type="button" className={"btnReset addToOrderBtn pointing"}
                                            onClick={() => setPopMeUp({ timestamp: Date.now(), itemId: props.itemId })}>
                                            לחץ לשינויים
                                        </button>
                                        <button type="button" className={"btnReset addToOrderBtn pointing"}
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                addDuplicate();
                                            }}>
                                            עוד אחד עם שינויים
                                        </button>
                                    </>
                                )}
                            </div>
                        }
                    </div>
                ) : (props.onlyPhone || props.myClass == null) ? "" :
                    <div className="statusAndCountBlock">
                        <div className="buttonsUnderImage">
                            <button type="button" className={"btnReset addToOrderBtn btnBottm pointing"} onClick={() => firstTimeOrdClick()}>
                                הוסף להזמנה
                            </button>
                        </div>
                    </div>}

                <div className="rightContent">
                    <div className={`MyFont mnuDivPrdcbold MbigFont`}>{props.divitm.prodName}</div>
                    {!imInOrder && <div className={"prodDetailsLong spaceTopBig"}>
                        <div className={"mnuDivPrdcReg"}>{props.divitm.prodProducts}</div>
                    </div>}
                    {((!master.blockDeliverys.block && !master.blockPickUps.block) && props.divitm.okToDeliver) ? <>
                        <div className={"prodOptions"}>
                            {(imInOrder) ?
                                props.divitm.isCombo ?
                                    props.divitm.prodOptions.length > 0 ?
                                        <ProductComboOptions
                                            product={props.divitm}
                                            PopMeUp={popMeUp}
                                            tempOrderProds={(prods) => tempOrderProds(prods)}
                                            itemId={props.itemId}
                                            imInOrder={imInOrder}
                                            removeFromOrder={() => removeFromOrder(props.itemId)}
                                            addDuplicate={() => addDuplicate()}
                                            inOrderIndex={inOrderIndex} />
                                        : ""
                                    :
                                    props.divitm.prodOptions.length > 0 ?
                                        <ProductOptions
                                            product={props.divitm}
                                            PopMeUp={popMeUp}
                                            tempOrderProds={(prods) => tempOrderProds(prods)}
                                            itemId={props.itemId}
                                            imInOrder={imInOrder}
                                            removeFromOrder={() => removeFromOrder(props.itemId)}
                                            addDuplicate={() => addDuplicate()}
                                            inOrderIndex={inOrderIndex} />
                                        : ""
                                : ""
                            }
                        </div>
                    </> :
                        !props.divitm.okToDeliver && <div className="notForDelivery">להזמנה במסעדה בלבד</div>
                    }

                    {((!master.blockDeliverys.block || !master.blockPickUps.block) && props.divitm.okToDeliver) &&
                        <div className={"priceln"}> ₪{props.divitm.prodPrice.toFixed(2)}</div>
                    }
                </div>
            </div>
        )
    }

    return (
        <div key={props.itemId} id={props.itemId} className={`${props.myClass} `} style={{ position: "relative" }}>
            {props.myClass && <div className={"overLay"}></div>}
            <div className={"prods"}>{smDisp()}</div>
            <div className={"duplis"}>{duplicates}</div>
        </div>
    );
}

export default ProductItemDeskTopRegular;